export const generateGuid = () => {
  let retGUID = ''
  for (let charOn = 0; charOn < 32; charOn++) {
    if ([8, 12, 16, 20].indexOf(charOn) >= 0) {
      retGUID += '-'
    }
    const valCur = Math.floor(Math.random() * 16)
    retGUID += String.fromCharCode(valCur < 10 ? 48 + valCur : 87 + valCur)
  }
  return retGUID
}

export default generateGuid
